export default __webpack_public_path__ + "static/pn-0c0506f8911b466432542e9baf138824.svg";